import type { CoverProps, CSSLength } from '@bedrock-layout/primitives'
import type React from 'react'

export type TXPosition = 'left' | 'center' | 'right'
export type TYPosition = 'top' | 'center' | 'bottom'
export const patternVariantsKeys = ['branches', 'angles', 'gear', 'arch', 'laurel', 'none'] as const
export type TPatternVariants = (typeof patternVariantsKeys)[number]
export type TPatternPosition = 'left' | 'right'

export interface TFullWidthTextSection extends CoverProps {
  colorTheme: string
  minHeight: CSSLength
  children?: React.ReactNode
  xAlign: TXPosition
  yAlign: TYPosition
  bgPattern?: TPatternVariants
  patternPosition?: TPatternPosition
}
